module.exports = __webpack_public_path__ + "static/img/portrait.747a53e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portrait.png
// module id = 96
// module chunks = 1